module.exports = __webpack_public_path__ + "3b3fcd552390bb2c23aca2ce02e2ce91.png";